import React, { useEffect, useState } from "react";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import FormCrearSubcategoria from "../elementos/complejos/FormCrearSubcategoria";
import FormEditarSubcategoria from "../elementos/complejos/FormEditarSubcategoria";
import { fechtOptenerModelos } from '../../peticiones_API/PeticionesCursoConvocatoria';
import Navbar from "../elementos/cuerpo/Navbar";
const GestorSubcategoria = ({ crear }) => {

  const [loading, setLoading] = useState(true);
  const [categorias, setCategorias] = useState();


  useEffect(() => {
    const fetchData = async () => {
      try {

        const listadoResponse = await fechtOptenerModelos(["Categoria"], true);
        console.log("listadoResponse", listadoResponse);
        setCategorias(listadoResponse.Categoria);


        setLoading(false);
      } catch (error) {
        console.log("Ha habido un error:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <>
      
        <ContenedorPrincipal formaform="true"  >

          {crear ?
            <FormCrearSubcategoria
            categorias={categorias}
            />
            :
            <FormEditarSubcategoria
            categorias={categorias}
            />
          }


        </ContenedorPrincipal>

    </>
  );
}

export default GestorSubcategoria;